import { Link } from "@tanstack/react-router";
import { getCourse } from "@/content/courses";
import type { LearningPath } from "@/content/learning-paths";

export const LANE_LABELS: Record<string, string> = {
  "new-leader": "New leaders",
  "experienced-leader": "Experienced leaders",
  "communication-conflict": "Communication and conflict",
  "developing-people": "Developing people",
  custom: "Built for your situation",
};

export function LearningPathCard({ path }: { path: LearningPath }) {
  return (
    <div className="flex h-full flex-col rounded-2xl border border-border/60 bg-background p-7 transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-[0_10px_30px_-8px_rgba(0,0,0,0.15)]">
      {LANE_LABELS[path.lane] && (
        <p className="text-xs font-semibold uppercase tracking-wider text-primary">
          {LANE_LABELS[path.lane]}
        </p>
      )}
      <h3 className="mt-2 font-display text-xl leading-snug text-ink">{path.name}</h3>
      <p className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">{path.audience}</p>
      <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{path.why}</p>

      <ol className="mt-6 space-y-3">
        {path.courseSlugs.map((slug, i) => {
          const course = getCourse(slug);
          if (!course) return null;
          return (
            <li key={slug} className="flex gap-3">
              <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-lavender text-xs font-semibold text-primary">
                {i + 1}
              </span>
              <span className="min-w-0">
                <Link
                  to="/course-catalog/$slug/"
                  params={{ slug }}
                  className="text-sm font-semibold text-ink hover:text-primary hover:underline"
                >
                  {course.title}
                </Link>
                {course.duration && (
                  <span className="mt-0.5 block text-xs text-muted-foreground">
                    {course.duration}
                  </span>
                )}
              </span>
            </li>
          );
        })}
      </ol>

      <p className="mt-6 border-t border-border/60 pt-4 text-xs uppercase tracking-wider text-muted-foreground">
        {path.courseSlugs.length} courses
      </p>
    </div>
  );
}
